import { render, staticRenderFns } from "./MfaSetting.vue?vue&type=template&id=53c3ceee"
import script from "./MfaSetting.vue?vue&type=script&lang=js"
export * from "./MfaSetting.vue?vue&type=script&lang=js"
import style0 from "./MfaSetting.vue?vue&type=style&index=0&id=53c3ceee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports